import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { CountryISO } from 'ngx-intl-tel-input';
import { SharedService } from '../../../shared/shared.service';
import { API_MODULES } from '../../../core/api-modules';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contact-uae',
  templateUrl: './contact-uae.component.html',
  styleUrls: ['./contact-uae.component.scss']
})
export class ContactUaeComponent implements OnInit {

  contactForm: FormGroup;

  cities = [
    'Dubai',
    'Abu Dhabi',
    'Sharjah',
    'Ajman',
    'Ras Al Khaimah',
    'Fujairah',
    'Umm Al Quwain'
  ];
  selectedCity = 'Dubai';
  selectedEnquiry = 'salesOman@unikai.com';

  enquiryTypes = [
    { label: 'Local Sales Enquiry', value: 'sales@unikai.com' },
    { label: 'International Sales', value: 'exports@unikai.com' },
    { label: 'Purchase', value: 'purdxb@unikai.com' },
    { label: 'Customer Care / Feedback', value: 'info@unikai.com' },
    { label: 'Investor Relations', value: 'investor.relations@unikai.com' }
  ];

  quickAddress = "P.O. Box 6424, Dubai, UAE";
  quickPhone = "800 UNIKAI (864524)";
  whatsappLink = "https://wa.me/971800864524";

  branches = [
    {
      title: "Unikai Head Office",
      address: "Unikai Foods PJSC, Al Quoz 1, Al Meydan Road, Dubai, UAE",
      phone: "+971 04-5708800",
      timing: "Monday to Saturday 8.30 am to 5.30 pm"
    },
    {
      title: "Unikai Shop Sharjah",
      address: "Grand Avenue Mall, Shop 29, Zubair Bin Qais St, Al Nasiriyah, Sharjah UAE",
      phone: "+971 04-5076508",
      timing: "Monday to Sunday – 9:00am – 11pm"
    },
    {
      title: "Khorfakkan Depot – Abu Dhabi",
      address: "Sheikh Khalid Bin Mohammed Al Qasimi St 8817, Khorfakkan, Sharjah UAE",
      phone: "+971 04-5076508",
      timing: "Monday to Saturday 8.30 am to 5.30 pm"
    }
  ];

  socialLinks = {
    linkedin: "https://www.linkedin.com/company/unikaifoodspjsc/posts/?feedView=all",
    instagram: "https://www.instagram.com/unikaifoods/",
    facebook: "https://www.facebook.com/unikaifoods/",
    tiktok: "https://www.tiktok.com/@unikaifoods"
  };

  CountryISO = CountryISO;
  /** Global min/max length for national number (same as careers page). */
  PHONE_NATIONAL_MIN = ContactUaeComponent.PHONE_NATIONAL_MIN;
  PHONE_NATIONAL_MAX = ContactUaeComponent.PHONE_NATIONAL_MAX;
  private static readonly PHONE_NATIONAL_MIN = 6;
  private static readonly PHONE_NATIONAL_MAX = 15;

  submitting = false;

  constructor(
    private fb: FormBuilder,
    private api: SharedService
  ) {
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', [Validators.required, this.phoneLengthValidator()]],
      email: ['', [Validators.required, Validators.email]],
      city: ['', Validators.required],
      subject: ['', Validators.required],
      enquiryType: ['', Validators.required],
      message: ['']
    });
  }

  ngOnInit(): void { }

  /** Validator: national number length between global min and max (all countries). */
  private phoneLengthValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: unknown } | null => {
      const v = control.value;
      if (!v || typeof v !== 'object' || v.nationalNumber == null) return null;
      const len = String(v.nationalNumber).replace(/\D/g, '').length;
      if (len > 0 &&
        (len < ContactUaeComponent.PHONE_NATIONAL_MIN || len > ContactUaeComponent.PHONE_NATIONAL_MAX)
      ) {
        return {
          phoneLength: {
            min: ContactUaeComponent.PHONE_NATIONAL_MIN,
            max: ContactUaeComponent.PHONE_NATIONAL_MAX,
            actual: len
          }
        };
      }
      return null;
    };
  }

  get defaultPhoneCountry(): CountryISO {
    return CountryISO.UnitedArabEmirates;
  }

  get preferredPhoneCountries(): CountryISO[] {
    return [CountryISO.UnitedArabEmirates, CountryISO.Oman];
  }

  private toPhoneString(value: any): string {
    if (!value || typeof value !== 'object') return '';
    return (
      (value.internationalNumber as string) ||
      (value.e164Number as string) ||
      (value.nationalNumber != null ? String(value.nationalNumber) : '')
    );
  }

  private buildPayload(): any {
    const v = this.contactForm.value;
    return {
      country: 'UAE',
      full_name: (v.name || '').trim(),
      mobile_number: this.toPhoneString(v.mobile),
      email: (v.email || '').trim(),
      emirate: v.city || '',
      subject: v.subject || '',
      enquiry_type: v.enquiryType || '',
      message: v.message || ''
    };
  }

  async onSubmit(): Promise<void> {
    if (!this.contactForm.valid) {
      this.contactForm.markAllAsTouched();
      return;
    }

    const payload = this.buildPayload();
    this.submitting = true;

    try {
      await this.api.create(API_MODULES.CONTACT, payload);

      await Swal.fire({
        icon: 'success',
        title: 'Thank you',
        text: 'Your message has been submitted successfully.',
        confirmButtonColor: '#022a72'
      });

      this.contactForm.reset({
        name: '',
        mobile: '',
        email: '',
        city: '',
        subject: '',
        enquiryType: '',
        message: ''
      });
    } catch (err) {
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Unable to submit your message. Please try again later.',
        confirmButtonColor: '#022a72'
      });
    } finally {
      this.submitting = false;
    }
  }

}

